import React, { useState } from "react";
import ImageGalleryModal from "./ImageGalleryModal";

function SectionContent({ sectionData, images, requiredForModal }) {
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    setGalleryOpen(true);
  };
  return (
    <>
      <div
        className={`report-content-box${!sectionData ? " is-empty" : ""}`}
        style={requiredForModal ? { background: "none", padding: "0" } : undefined}
      >
        {sectionData ? (
          <div
            dangerouslySetInnerHTML={{
              __html: sectionData.replace(/\n/g, "<br/>"),
            }}
          />
        ) : (
          "NA"
        )}
      </div>
      {images && images.length > 0 && (
        <>
          <div className="report-images-grid">
            {images.map((image, index) => (
              <div
                key={index}
                className="report-image-thumbnail"
                onClick={() => handleImageClick(index)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => e.key === 'Enter' && handleImageClick(index)}
              >
                <img
                  src={image.preview || image.url}
                  alt={image.name || `Image ${index + 1}`}
                />
                <div className="thumbnail-overlay">
                  <span className="thumbnail-icon">🔍</span>
                </div>
              </div>
            ))}
          </div>
          <ImageGalleryModal
            images={images}
            initialIndex={selectedImageIndex}
            isOpen={galleryOpen}
            onClose={() => setGalleryOpen(false)}
          />
        </>
      )}
    </>
  );
}

export default SectionContent;
